import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getId = (state: RootState) => state.pages.editor.scene.id;

const getSceneId = createSelector([getId], (id) => id);

export default getSceneId;
